import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/api/auth.service';
import { DashboardService } from '../services/api/dashboard.service';
import { FormatogsPipe } from '../../../shared/pipes/formatogs.pipe';

@Component({
    selector: 'app-statswidget',
    standalone: true,
    imports: [FormatogsPipe],
    templateUrl: './statswidget.component.html',
    styleUrl: './statswidget.component.scss'
})
export class StatswidgetComponent implements OnInit {
    // dashboardDto: DashboardDto = {} as DashboardDto;

    private _authService = inject(AuthService);

    private _dashboardService = inject(DashboardService);

    countOrdersToday: number = 0;
    countOrdersMonth: number = 0;
    countOutstandingBalance: number = 0;
    countTotalAmountDay: number = 0;

    amount: number = 0;
    amountBalance: number = 0;

    rolUser = this._authService.getUserRoles();

    constructor() {
        // constructor(private _dashboardService: DashboardService) {
        this._dashboardService.getDatosStatsWidgets().subscribe((resp) => {
            if (resp.status) {
                console.log(resp.objeto);
                this.countOrdersToday = resp.object.countOrdersDaily;
                this.countOrdersMonth = resp.object.countOrdersMonthly;
                this.countOutstandingBalance = resp.object.countOutstandingBalance;
                this.countTotalAmountDay = resp.object.countTotalAmountDay;
            }
        });
    }

    ngOnInit() {}

    haveRole(role: string): boolean {
        return this.rolUser.includes(role);
    }
}
